import { createSlice } from '@reduxjs/toolkit';
import { IRootState } from 'types';

const initialState: IRootState = {
  isUIVersionOutOfDate: false,
  navigationState: {}
};

const slice = createSlice({
  name: 'root',
  initialState,
  reducers: {
    resetRootState(state) {
      return {
        ...initialState
      };
    },

    setIsUIVersionOutOfDate: (state, action) => {
      state.isUIVersionOutOfDate = action.payload;
    },

    setNavigationState: (state, action) => {
      state.navigationState = action.payload;
    }
  }
});

export default slice.reducer;
export const { resetRootState, setIsUIVersionOutOfDate, setNavigationState } = slice.actions;
